import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { getCentralisationInsurerLabel } from 'src/app/_enums/centralisation-insurer.enum';
import { InsuranceFlowStatus } from 'src/app/_enums/insurance-flow/insurance-flow-status.enum';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import { AddExistingContractComponent } from 'src/app/shared/components/add-existing-contract/add-existing-contract.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { TaskDetailsService } from '../../../../task-details.service';
import { BaseStepperAction } from '../../../task-history/stepper-actions/base-action';

type CentralisationPolicyPrefill = {
  insuranceType: InsuranceType;
  companyId?: string;
  companyName?: string;
  insurer?: string;
};

@Component({
  selector: 'app-create-centralisation-policy-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    IconsModule,
    AddExistingContractComponent,
  ],
  templateUrl: './create-centralisation-policy.component.html',
})
export class CreateCentralisationPolicyComponent extends BaseStepperAction {
  @ViewChild('contractModal') contractModal: AddExistingContractComponent;

  get enabled(): boolean {
    return (
      this.state?.insuranceFlowData?.status ===
      InsuranceFlowStatus.ONGOING_CENTRALISATION
    );
  }

  get userId(): string {
    return this.state?.insuranceFlowData?.userId;
  }

  get centralisationId(): string {
    return this.state?.lead?.leadId;
  }

  get insuranceType(): InsuranceType | null {
    return this.centralisationPolicyPrefill?.insuranceType ?? null;
  }

  get insurer(): string | null {
    const prefill = this.centralisationPolicyPrefill;
    if (!prefill) {
      return null;
    }
    if (prefill.companyId) {
      return prefill.companyName ?? prefill.companyId;
    }
    return prefill.insurer
      ? getCentralisationInsurerLabel(prefill.insurer)
      : null;
  }

  private get centralisationPolicyPrefill(): CentralisationPolicyPrefill | null {
    const metadata = this.state?.lead?.metadata;
    if (metadata?.type !== InsuranceType.CENTRALISATION) {
      return null;
    }

    let firstAvailablePrefill: CentralisationPolicyPrefill | null = null;
    for (const insurerInfo of metadata.trackingInfo ?? []) {
      for (const insuranceInfo of insurerInfo?.insurances ?? []) {
        if (!insuranceInfo?.insurance) {
          continue;
        }

        const prefill: CentralisationPolicyPrefill = {
          insuranceType: insuranceInfo.insurance,
          companyId: insurerInfo.companyId,
          companyName: insurerInfo.companyName,
          insurer: insurerInfo.insurer,
        };
        firstAvailablePrefill ??= prefill;

        if (!insuranceInfo.done) {
          return prefill;
        }
      }
    }

    return firstAvailablePrefill;
  }

  constructor(taskDetailsService: TaskDetailsService) {
    super(taskDetailsService);
  }
}
